import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import StickyContainer from '@/patterns/sticky-container/sticky-container';
import { JiraSitesProvider } from '@/templates/software/jira/logged-in/paid-logged-in/jira-sites-provider/jira-sites-provider';
import SoftwareJiraLoggedInNavbar from '@/templates/software/jira/logged-in/paid-logged-in/logged-in-nav/software-jira-logged-in-navbar';

import { ParentScrollTracking } from '../../../../../utils/scroll-tracking/parent-scroll-tracker';

import { LoggedInHeroSection } from './logged-in-hero';

export const PaidLoggedInJiraProductTourOverview = () => {
	return (
		<div>
			<JiraSitesProvider>
				<StickyContainer>
					<SoftwareJiraLoggedInNavbar />
				</StickyContainer>
				<ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
					<LoggedInHeroSection />
					{/* @ts-ignore */}
					<GlobalFooter fullWidth={true} />
				</ParentScrollTracking>
			</JiraSitesProvider>
		</div>
	);
};
